import React from 'react';
import { ArrowUpRight, Users } from 'lucide-react';
import { TID } from '@/testIds';

export default function GuildBanner() {
  return (
    <section id="installer-guild" className="relative border-b mi-line overflow-hidden">
      <div
        className="absolute inset-0 opacity-20 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/17370583/pexels-photo-17370583.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-[#0d0d0f]" />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-24">
        <div className="grid lg:grid-cols-[1.1fr_1fr] gap-12 items-center">
          <div>
            <div className="mi-eyebrow mb-4 text-[#E63946]">// B2B PARTNERSHIP</div>
            <h2 className="mi-headline text-4xl md:text-5xl lg:text-6xl mb-6">
              Need an installer <span className="text-[#E63946]">on the ground?</span>
            </h2>
            <p className="text-white/75 leading-relaxed text-lg mb-8 max-w-xl">
              Meet <span className="text-white font-semibold">Install Guild</span> — our sister platform connecting
              print shops, sign companies and brands to vetted wrap installers nationwide. Post a job,
              get bids, get it wrapped. No middleman markups.
            </p>
            <div className="flex flex-wrap items-center gap-4">
              <a
                href="https://www.installguild.pro"
                target="_blank"
                rel="noopener noreferrer"
                data-testid={TID.guildBannerCta}
                className="mi-btn-red"
              >
                Visit Install Guild <ArrowUpRight className="w-4 h-4" />
              </a>
              <a href="#installer-join" className="mi-btn-ghost">
                <Users className="w-4 h-4" /> Apply as installer
              </a>
            </div>
          </div>

          <div className="relative">
            <div className="mi-surface p-6 lg:p-8 mi-line-strong">
              <div className="mi-eyebrow mb-4">// INSTALL GUILD · SNAPSHOT</div>
              <div className="grid grid-cols-2 gap-6 mb-6">
                {[
                  ['400+', 'VETTED PROS'],
                  ['48H', 'AVG BID'],
                  ['48', 'STATES COVERED'],
                  ['4.9★', 'AVG RATING'],
                ].map(([k, v]) => (
                  <div key={v}>
                    <div className="mi-headline text-4xl text-white">{k}</div>
                    <div className="mi-eyebrow mt-1">{v}</div>
                  </div>
                ))}
              </div>
              <div className="mi-sep my-6" />
              <div className="flex items-center justify-between">
                <span className="font-mono-data text-xs text-white/50">installguild.pro</span>
                <span className="mi-tag mi-tag-red">POWERED BY MOTOR iNKS</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
